var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H1, Prose } from '@criteria-labs/react-typography';
import { Article } from '../article';
import { Column, ColumnLayout } from '../column-layout';
import { EndpointsFigure } from './EndpointsFigure';
import { ResourceOverviewSection } from './ResourceOverviewSection';
export function ResourceArticle(_a) {
    var { resource } = _a, props = __rest(_a, ["resource"]);
    return (_jsxs(Article, Object.assign({}, props, { children: [_jsx(Prose, { className: "max-w-none mb-6", children: _jsx(H1, { children: resource.summary }) }), _jsxs(ColumnLayout, { children: [_jsx(Column, { children: _jsx(ResourceOverviewSection, { resource: resource }) }), _jsx(Column, { children: _jsx(EndpointsFigure, { resource: resource }) })] })] })));
}
